import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20beige%20and%20sage%20green%20abstract%20gradient%20background%20with%20gentle%20organic%20flowing%20shapes%2C%20subtle%20texture%20like%20linen%20fabric%2C%20minimalist%20artistic%20composition%2C%20calm%20serene%20atmosphere%2C%20luxurious%20spa-like%20aesthetic%2C%20elegant%20negative%20space%2C%20modern%20sophisticated%20feel&width=1800&height=1000&seq=hero-main-bg-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet product research platform with organized shopping database"
          title="Kakobuy Spreadsheet shopping research"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/70 rounded-full mb-5">
              <div className="w-1.5 h-1.5 rounded-full bg-primary-500"></div>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">Updated Spreadsheet Database</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-900 leading-tight mb-5">
              Kakobuy Spreadsheet
              <br />
              <span className="text-primary-500">Smart Shopping Database</span>
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-7">
              Access updated Kakobuy Spreadsheet collections, product comparisons, category guides, and expert shopping research tools designed to help you discover better products faster.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                Kakobuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/kakobuy-spreadsheet-guide"
                className="w-full sm:w-auto px-7 py-3 border border-foreground-200 text-foreground-700 hover:text-primary-600 hover:border-primary-400 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="flex flex-wrap items-center gap-4 mt-7 justify-center lg:justify-start text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-primary-500"></i> Updated Database
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-primary-500"></i> Detailed Comparisons
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-primary-500"></i> Shopping Safety Guides
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-primary-500"></i> Beginner Friendly
              </span>
            </div>
          </div>
          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20overhead%20flat%20lay%20of%20diverse%20lifestyle%20products%20on%20warm%20sand%20colored%20linen%20including%20woven%20straw%20bag%20ceramic%20coffee%20cup%20linen%20notebook%20wooden%20sunglasses%20and%20small%20succulent%20plant%2C%20soft%20natural%20window%20light%2C%20minimalist%20boho%20aesthetic%2C%20organic%20textures%2C%20calm%20mindful%20composition&width=900&height=675&seq=hero-side-product-v3&orientation=landscape"
                  alt="Curated product finds from Kakobuy Spreadsheet database"
                  title="Kakobuy Spreadsheet product finds"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-4 py-3 border border-background-200">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-database-2-line text-primary-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-foreground-900 whitespace-nowrap">500+ Products</div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">Updated weekly</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}